import { useState } from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Card,
  CardBody,
  Collapse,
} from "reactstrap";

import { useLocation } from "react-router-dom";

// import ImportGroup from './ImportGroups';
// import ImportParticipant from './ImportParticipant';
import ImportTransfer from "./ImportTransfer";
import ImportTransferVehicle from "./ImportTransferVehicle";
import ImportUpdateTransfer from "./ImportUpdateTransfer";
import ImportDeleteTransfer from "./ImportDeleteTransfer";
import SectionComponent from "../../Apps/Personalization/SectionComponent";

export default function ModalImportWrapper(props) {
  const { isOpen, toggle, idEvent, data, token } = props;
  const location = useLocation();

  const [collapseTransferIsOpen, setCollapseTransferIsOpen] = useState(false);
  const [collapseUpdateTransfer, setCollapseUpdateTransfer] = useState(false);
  const [collapseDeleteTransfer, setCollapseDeleteTransfer] = useState(false);
  const [collapseVehicleIsOpen, setCollapseVehicleIsOpen] = useState(false);

  const [activeImport, setActiveImport] = useState(false);

  function toggleBackdrop() {
    setCollapseVehicleIsOpen(false);
    setCollapseTransferIsOpen(false);
    setCollapseUpdateTransfer(false);
    setCollapseDeleteTransfer(false);
    toggle();
  }

  function toggleCollapseTransfer() {
    if (activeImport) return;
    setCollapseVehicleIsOpen(false);
    setCollapseTransferIsOpen(!collapseTransferIsOpen);
    setCollapseUpdateTransfer(false);
    setCollapseDeleteTransfer(false);
  }

  function toggleCollapseUpdateTransfer() {
    if (activeImport) return;
    setCollapseVehicleIsOpen(false);
    setCollapseTransferIsOpen(false);
    setCollapseUpdateTransfer(!collapseUpdateTransfer);
    setCollapseDeleteTransfer(false);
  }

  function toggleCollapseDeleteTransfer() {
    if (activeImport) return;
    setCollapseVehicleIsOpen(false);
    setCollapseTransferIsOpen(false);
    setCollapseUpdateTransfer(false);
    setCollapseDeleteTransfer(!collapseDeleteTransfer);
  }

  function toggleCollapseVehicle() {
    if (activeImport) return;
    setCollapseVehicleIsOpen(!collapseVehicleIsOpen);
    setCollapseTransferIsOpen(false);
    setCollapseUpdateTransfer(false);
    setCollapseDeleteTransfer(false);
  }

  function activatedImport(status) {
    setActiveImport(status);
  }

  function setNull() {}

  function checkProductExists(product) {
    const search = location.state.event.product.filter(
      (e) => e.name === product,
    );

    if (search[0]) {
      return true;
    } else return false;
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => toggleBackdrop()}
      autoFocus={true}
      centered={true}
    >
      <ModalHeader toggle={() => toggleBackdrop()}>
        Importador de Transfers
      </ModalHeader>
      <ModalBody className="m-1 p-0">
        <Card className="p-1">
          <CardBody className="m-1 p-2">
            <h4
              style={{
                textAlign: "center",
              }}
            >
              Transfers
            </h4>

            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "245px",
              }}
            >
              <SectionComponent
                sectionName="Importar Transfers"
                setIsOpen={!activeImport ? toggleCollapseTransfer : setNull}
                isOpen={collapseTransferIsOpen}
              />
            </Row>

            <Collapse isOpen={collapseTransferIsOpen}>
              {/* <ImportParticipant
                  isOpen={isOpen}
                  toggle={toggleBackdrop}
                  active={activatedImport}
                  getAllParticipants={getAllParticipants}
                  token={token}
                  idEvent={idEvent}
                /> */}
              <ImportTransfer
                isOpen={isOpen}
                toggle={toggleBackdrop}
                token={token}
                idEvent={idEvent}
                data={data}
              />
            </Collapse>

            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "245px",
              }}
            >
              <SectionComponent
                sectionName="Atualizar Transfers"
                setIsOpen={
                  !activeImport ? toggleCollapseUpdateTransfer : setNull
                }
                isOpen={collapseUpdateTransfer}
              />
            </Row>

            <Collapse isOpen={collapseUpdateTransfer}>
              <ImportUpdateTransfer
                toggleModal={toggle}
                idEvent={idEvent}
                data={data}
              />
            </Collapse>

            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "245px",
              }}
            >
              <SectionComponent
                sectionName="Deletar Transfers"
                setIsOpen={
                  !activeImport ? toggleCollapseDeleteTransfer : setNull
                }
                isOpen={collapseDeleteTransfer}
              />
            </Row>

            <Collapse isOpen={collapseDeleteTransfer}>
              <ImportDeleteTransfer
                toggleModal={toggle}
                idEvent={idEvent}
                data={data}
              />
            </Collapse>

            {checkProductExists("Inteegra MOBI") && (
              <>
                <h4
                  style={{
                    textAlign: "center",
                    marginTop: 20,
                  }}
                >
                  Veículos
                </h4>

                <Row
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: 10,
                    width: "280px",
                  }}
                >
                  <SectionComponent
                    sectionName="Participantes por Veículos"
                    setIsOpen={!activeImport ? toggleCollapseVehicle : setNull}
                    isOpen={collapseVehicleIsOpen}
                  />
                </Row>

                <Collapse isOpen={collapseVehicleIsOpen}>
                  {/* <ImportGroup
                  isOpen={isOpen}
                  toggle={toggleBackdrop}
                  active={activatedImport}
                  idEvent={idEvent}
                  token={token}
                  getAllParticipants={getAllParticipants}
                /> */}
                  <ImportTransferVehicle
                    isOpen={isOpen}
                    toggle={toggleBackdrop}
                    token={token}
                    idEvent={idEvent}
                    data={data}
                  />
                </Collapse>
              </>
            )}
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
}
